<!-- Modal Container with Flexbox Layout -->
<div class="modal-container" [class.minimized]="minimise">
  <!-- STANDARD Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">Form 1118 Config {{ isEdit ? 'Edit' : 'Add' }}</h3>
    <div class="header-actions">
      <i class="fa"  
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
         style="margin-right: 10px; cursor: pointer;"  
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- STANDARD Modal Body -->
  @if (!minimise) {
<div class="modal-body">
  <div class="panel-body">
    <div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="filerentity">Filer Entity</label>
            <!-- Add Mode: Searchable Multi-select dropdown -->
            @if (!isEdit) {
<div class="searchable-multiselect-container">
              <div class="custom-searchable-multiselect" 
                   #filerEntityDropdown
                   [class.open]="filerEntityDropdownOpen">
                <div class="dropdown-input-wrapper" 
                     (click)="toggleFilerEntityDropdown()">
                  <input type="text" 
                         class="form-control dropdown-input" 
                         [value]="getSelectedFilerEntitiesDisplay()"
                         readonly
                         placeholder="Select Filer Entities">
                  <i class="fa fa-chevron-down dropdown-arrow" 
                     [ngClass]="{'fa-chevron-up': filerEntityDropdownOpen, 'fa-chevron-down': !filerEntityDropdownOpen}"></i>
                </div>
                @if (filerEntityDropdownOpen) {
<div class="dropdown-menu" 
                    
                     (click)="$event.stopPropagation()">
                  <div class="dropdown-search-wrapper">
                    <input type="text" 
                           class="form-control dropdown-search-input" 
                           [(ngModel)]="filerEntitySearchText"
                           (ngModelChange)="onFilerEntitySearchChange()"
                           placeholder="Search filer entities..."
                           (click)="$event.stopPropagation()">
                    <i class="fa fa-search dropdown-search-icon"></i>
                  </div>
                  <div class="dropdown-actions">
                    <button type="button" 
                            class="btn btn-link btn-sm select-all-btn"
                            (click)="selectAllFilerEntities(); $event.stopPropagation()">
                      Select All
                    </button>
                    <button type="button" 
                            class="btn btn-link btn-sm unselect-all-btn"
                            (click)="unselectAllFilerEntities(); $event.stopPropagation()">
                      Unselect All
                    </button>
                  </div>
                  <div class="dropdown-items-wrapper">
                    @if (filerEntityFilteredData.length === 0) {
<div 
                         class="dropdown-no-results">
                      No results found
                    </div>
}
                    @for (option of filerEntityFilteredData; track $index) {
<div 
                         class="dropdown-item checkbox-item"
                         [class.disabled]="option.FILER_LE_KEY === ''"
                         (click)="!isCheckboxClick($event) && toggleFilerEntitySelection(option); $event.stopPropagation()">
                      <input type="checkbox" 
                             [checked]="isFilerEntitySelected(option.FILER_LE_KEY)"
                             [disabled]="option.FILER_LE_KEY === ''"
                             (change)="toggleFilerEntitySelection(option); $event.stopPropagation()"
                             (click)="$event.stopPropagation()">
                      <label [class.disabled]="option.FILER_LE_KEY === ''"
                             (click)="toggleFilerEntitySelection(option); $event.stopPropagation()">
                        {{ option.FILER_LE }}
                      </label>
                    </div>
}
                  </div>
                </div>
}
              </div>
            </div>
}
            <!-- Edit Mode: Single Select (Disabled) -->
            @if (isEdit) {
<select
                    id="filerentity" 
                    class="form-control" 
                    [(ngModel)]="filerEntityEdit" 
                    [disabled]="true"
                    [compareWith]="compareFilerEntityOptions">
              <option [ngValue]="null">SELECT</option>
              @for (option of filingEnityDetails; track $index) {
<option 
                      [ngValue]="option">
                {{ option.FILER_LE }}
              </option>
}
            </select>
}
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="config_name">Schedule</label>
            <select id="config_name"
                    class="form-control" 
                    [(ngModel)]="configName"
                    [disabled]="isEdit"
                    [compareWith]="compareConfigOptions">
              <option [ngValue]="null">SELECT</option>
              @for (option of configNameDetails; track $index) {
<option 
                      [ngValue]="option">
                {{ option.LINE_DESCRIPTION }}
              </option>
}
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="checkbox" style="margin-top:30px;">
            <label>
              <input type="checkbox" [(ngModel)]="checkboxOrSelectValue" />
            </label>
          </div>
        </div>
      </div>
      <!-- STANDARD Footer -->
      <div class="modal-footer-inline">
        <button class="save-button"  
                type="button"  
                [disabled]="isSaveClicked || crudLoading"  
                (click)="save()"> 
          @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
        </button>
        <button class="reset-button"  
                type="button"  
                (click)="reset()">Reset</button>
        <button class="cancel-button"  
                type="button"  
                (click)="cancel()">Cancel</button>
      </div>
    </div>
  </div>
</div>
}
</div>

